var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalproductSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 8.5,
    fill: "#F7F7F7",
    stroke: "#EBEAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.0013L15 11.668H25L27.5 15.0013M12.5 15.0013V26.668C12.5 27.11 12.6756 27.5339 12.9882 27.8465C13.3007 28.159 13.7246 28.3346 14.1667 28.3346H25.8333C26.2754 28.3346 26.6993 28.159 27.0118 27.8465C27.3244 27.5339 27.5 27.11 27.5 26.668V15.0013M12.5 15.0013H27.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 18.332C23.3327 19.2161 22.9815 20.0639 22.3564 20.6891C21.7313 21.3142 20.8834 21.6654 19.9993 21.6654C19.1153 21.6654 18.2674 21.3142 17.6423 20.6891C17.0172 20.0639 16.666 19.2161 16.666 18.332",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalproductSvg);
export default __webpack_public_path__ + "static/media/digitalproductSvg.a9ccb1f2550af2fa5cb28fee5711f2b0.svg";
export { ForwardRef as ReactComponent };